// extracted by mini-css-extract-plugin
export default {"date":"QSuXzF7h","header":"qgNuCEyw","mobile":"_S2QbhcT"};